import type { FC } from 'react';

import { ComponentsHead } from '@/components/head';
import { AddOnsTemplate } from '@/components/add-ons/template';
import { AnchorWithTitle } from '@/components/links/anchor';
import { LinkWithTitle } from '@/components/links';
import { h3 } from '@/styles/components/titles.module.scss';

export const GASPARILLA_PARADE_TITLE = 'Gasparilla Parade';

export const Head = () => {
  return (
    <ComponentsHead
      title="Gasparilla Boat Charter | Tampa Pirate Festival Experience"
      description="Don’t just watch Gasparilla — live it on the water. Secure your pirate crew’s private charter for Tampa Bay’s wildest day of the year."
      keywords="Gasparilla, Pirate Invasion, Tampa Events, Party Cruise"
    />
  );
};

const SpecialEventsGasparillaParade: FC = () => {
  return (
    <AddOnsTemplate
      title="Gasparilla Boat Charters – Tampa’s Ultimate Pirate Invasion Party"
      subtitle="Gasparilla Parade Charter Experience"
    >
      <h3 className={h3}>
        A Front-Row Seat to Tampa’s Most Iconic Tradition
      </h3>
      <p>
        Come on board and become a part of Tampa’s
        Gasparilla Parade Charter – one of the area’s most
        celebrated traditions. Once a year, the Tampa Bay
        region transforms into a pirate’s paradise hosting
        the{' '}
        <AnchorWithTitle href="https://gasparillapiratefest.com/">
          iconic Parade of Pirates
        </AnchorWithTitle>
        . The Parade makes its way along the Bayshore
        Boulevard and then moves into Downtown Tampa, where
        you will see thousands of people dressed as Pirates
        celebrating legendary pirate Jose Gaspar. The best
        way to experience this celebration? From the water,
        of course!
      </p>
      <p>
        At Tampa Bay Boating Adventures, we love taking part
        in the traditions of the Tampa area, sharing it with
        our guests. We offer an exclusive
        <LinkWithTitle to="/services/4-hour-private-party-boat-charter/">
          {' '}
          4-hour-long captained boat charter
        </LinkWithTitle>
        , where you and your guests can access an unmatched
        view of the pirate invasion, and boats cruising
        along the water. The charter begins from the Davis
        Island boat ramp, and sails along the parade route,
        immersing you in the festival. Our TBBA Adventure I
        boat can accommodate up to 12 guests, while our more
        spacious Paradiso vessel can hold up to 30 – so
        bring your friends along to celebrate with you!
      </p>
      <h3 className={h3}>
        All-Inclusive Luxury on the Water
      </h3>
      <p>
        Travel the parade in style with our top-quality
        charter cruises. We provide a U.S. Coast
        Guard-certified captain, who will do the hard work
        for you, allowing you to sit back, relax and enjoy
        the celebrations. Our boats come equipped with
        comfortable seating, Bluetooth-compatible speakers
        for background music, coolers with ice and bottled
        water, and access to swimming and floating
        platforms. We work with our guests to create the
        perfect day – offering a number of{' '}
        <LinkWithTitle to="/faqs/">add-ons</LinkWithTitle>{' '}
        such as catering, decorations, or a professional
        photographer are available to further personalize
        your experience.
      </p>
      <p>
        Due to the immense popularity of this event, early
        booking is essential. We recommend securing your
        charter at least a month in advance to guarantee
        your spot for this unforgettable experience.
      </p>
    </AddOnsTemplate>
  );
};

export default SpecialEventsGasparillaParade;
